module.exports = __webpack_public_path__ + "static/media/participles1_img.710c69c5.JPG";